var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "shareWrapper" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-sm btn-secondary",
        attrs: {
          id: "shareBtn",
          "aria-label": _vm.$translate("Ecomsilio::Template.shareButtonText"),
        },
        on: { click: _vm.handleShare },
      },
      [
        _c("i", {
          staticClass: "fa fa-share-alt",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "share_text" }, [
          _vm._v(
            _vm._s(_vm.$translate("Ecomsilio::Template.shareButtonText")) +
              "\n    "
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShareMenuVisible,
            expression: "isShareMenuVisible",
          },
        ],
        staticClass: "share-menu",
        attrs: { id: "shareMenu" },
      },
      [
        _c("ul", { ref: "shareMenuList" }, [
          _c("li", { on: { click: _vm.toggleShareMenu } }, [
            _c(
              "a",
              {
                attrs: {
                  id: "fbShare",
                  href: _vm.facebookUrl,
                  target: "_blank",
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-facebook-square",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v("Facebook"),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", { on: { click: _vm.toggleShareMenu } }, [
            _c(
              "a",
              { attrs: { id: "xShare", href: _vm.xUrl, target: "_blank" } },
              [
                _c("i", {
                  staticClass: "fa fa-twitter-square",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v("X (Twitter)"),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", { on: { click: _vm.toggleShareMenu } }, [
            _c(
              "a",
              {
                attrs: {
                  id: "pinterestShare",
                  href: _vm.pinterestUrl,
                  target: "_blank",
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-pinterest-square",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v("Pinterest"),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", { on: { click: _vm.toggleShareMenu } }, [
            _c("a", { attrs: { id: "emailShare", href: _vm.emailUrl } }, [
              _c("i", {
                staticClass: "fa fa-envelope",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v("E-Mail"),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { on: { click: _vm.copyLink } }, [
            _c(
              "button",
              { staticClass: "copy-link", attrs: { id: "copyLinkShare" } },
              [
                _c("i", {
                  staticClass: "fa fa-link",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(
                  _vm._s(_vm.$translate("Ecomsilio::Template.shareCopyLink")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }